import { render, staticRenderFns } from "./hojas-seguridad.vue?vue&type=template&id=eeb13018&scoped=true&"
import script from "./hojas-seguridad.vue?vue&type=script&lang=js&"
export * from "./hojas-seguridad.vue?vue&type=script&lang=js&"
import style0 from "./hojas-seguridad.vue?vue&type=style&index=0&id=eeb13018&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb13018",
  null
  
)

export default component.exports